const fetchFileFromUrl = async (url: string): Promise<any> => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();

        const urlWithoutQuery = url.split('?')[0];
        const fileExtension = urlWithoutQuery.substring(urlWithoutQuery.lastIndexOf('.'));
        const name = urlWithoutQuery.substring(urlWithoutQuery.lastIndexOf('/') + 1, urlWithoutQuery.lastIndexOf('.'));

        const file = new window.File([blob], `${name}.${fileExtension}`, {type: blob.type});

        return {
            file,
            fileExtension
        }
    } catch (error) {
        console.error("Failed to fetch file from defaultValue URL:", error);
    }
};


export default fetchFileFromUrl;